import clsx from "clsx";

import { Icon } from "../icon";

export const RequiredAsterisk = ({ className }: { className?: string }) => (
  <Icon
    className={clsx("w-4 h-4 mx-2 text-red-550", className)}
    name="regularAsterisk"
  />
);
